import Vue from "vue";

Vue.mixin({
    mounted()
    {
        if (this.$root !== this)
        {
            return;
        }

        this.$root.$on("aside-toggled", (val) =>
        {
            document.body.classList.toggle("aside-open", val);
        });
    }
});
